import dayjs from 'dayjs';

/**
 * 日付が祝日か返す
 * @param date
 */
export const isHoliday = function (holidays: string[], date?: string | Date) {
  return holidays.includes(dayjs(date || new Date()).format(`YYYY-MM-DD`));
};

export default isHoliday;
